<template>
  <footer class="bg-white border-t border-gray-200 mt-12">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div class="grid grid-cols-1 md:grid-cols-4 gap-8">
        <div>
          <h3 class="text-lg font-semibold text-gray-800 mb-4">Research Portal</h3>
          <p class="text-gray-600 text-sm">Connecting researchers in Mindoro State University with the latest scientific discoveries and academic publications.</p>
        </div>
        <div>
          <h4 class="text-sm font-semibold text-gray-800 uppercase tracking-wider mb-4">Explore</h4>
          <ul class="space-y-2">
            <li><a href="#" @click="$emit('update-view', 'browse')" class="text-sm text-gray-600 hover:text-green-600">Journals</a></li>
            <li><a href="#" class="text-sm text-gray-600 hover:text-green-600">Topics</a></li>
            <li><a href="#" class="text-sm text-gray-600 hover:text-green-600">Authors</a></li>
            <li><a href="/institution" class="text-sm text-gray-600 hover:text-green-600">Institutions</a></li>
          </ul>
        </div>
        <div>
          <h4 class="text-sm font-semibold text-gray-800 uppercase tracking-wider mb-4">Resources</h4>
          <ul class="space-y-2">
            <li><a href="/minsu-author-guidelines" class="text-sm text-gray-600 hover:text-green-600">Author Guidelines</a></li>
            <li><a href="https://daluyangdunong.minsu.edu.ph/api/author-guidelines/Manuscript Template DDMRJ.docx" class="text-sm text-gray-600 hover:text-green-600">Research Article Template</a></li>
            <li><a href="/publication/ethics" class="text-sm text-gray-600 hover:text-green-600">Publication Ethics</a></li>
            <li><a href="#" class="text-sm text-gray-600 hover:text-green-600">Research Tools</a></li>
            <li><a href="#" class="text-sm text-gray-600 hover:text-green-600">Help Center</a></li>
          </ul>
        </div>
        <div>
          <h4 class="text-sm font-semibold text-gray-800 uppercase tracking-wider mb-4">Connect</h4>
          <ul class="space-y-2">
            <li><a href="#" @click="$emit('update-view', 'about')" class="text-sm text-gray-600 hover:text-green-600">About Us</a></li>
            <li><a href="#" @click="$emit('update-view', 'contact')" class="text-sm text-gray-600 hover:text-green-600">Contact</a></li>
            <li><a href="#" @click="$emit('update-view', 'careers')" class="text-sm text-gray-600 hover:text-green-600">Careers</a></li>
            <li><a href="#" @click="$emit('update-view', 'newsletter')" class="text-sm text-gray-600 hover:text-green-600">Newsletter</a></li>
          </ul>
        </div>
      </div>
      <div class="mt-8 pt-8 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center">
        <p class="text-sm text-gray-500">© 2025 DDMRJ Online Journal System powered by <a href="https://www.facebook.com/iamchristiancabrera">Christian I. Cabrera. </a>. All rights reserved.</p>
        <div class="flex space-x-6 mt-4 md:mt-0">
          <a href="#" class="text-gray-400 hover:text-gray-500">
            <i class="fab fa-twitter"></i>
          </a>
          <a href="https://www.facebook.com/reserca.officium" class="text-gray-400 hover:text-gray-500">
            <i class="fab fa-facebook"></i>
          </a>
          <a href="#" class="text-gray-400 hover:text-gray-500">
            <i class="fab fa-linkedin"></i>
          </a>
          <a href="#" class="text-gray-400 hover:text-gray-500">
            <i class="fab fa-youtube"></i>
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterComponent',
  emits: ['update-view']
}
</script>